<ng-container *ngIf="showReporterButtons">
  <a class="container simple desktop card-shadow" [href]="linkToReporter" appClearHref target="_blank">
    <div class="profile-row">
      <div class="img-col">
        <mat-icon>person</mat-icon>
      </div>
      <div class="text-col">
        <span class="bold">Spiel tickern</span>
        <span>Du bist Reporter des Spiels - halte deine Fans am Laufenden!</span>
      </div>
    </div>

    <div class="input-row">
      <span>Was gibt’s Neues beim Spiel?</span>
    </div>
  </a>
</ng-container>
